<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
       Academic Term
    </button>

    <a-modal v-model="visible" title="Add a new Academic Term">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add Term</a-button>
      </template>

      <a-form class="mb-4 row" :form="form">
        <a-form-item label="Academic Term " class="col-md-6">
          <a-input
              v-decorator="[
              'name',
              {rules: [{ required: true, message: 'Please input the term name' }],},
              ]"
              placeholder="e.g. First Term, Second Term, Third Term"
          />
        </a-form-item>
        <a-form-item label="Session" class="col-md-6">
            <a-select
                v-decorator="[
                'session_id',
                {rules: [{ required: true, message: 'Please select a session' }],},
                ]"
                placeholder="Select a session"
            >
              <a-select-option v-for="session in sessions" :key="session.id" :value="session.id">{{ session.name }}</a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item label="Start Date" class="col-md-6">
          <a-date-picker
              v-decorator="[
              'start_date',
              {rules: [{ required: true, message: 'Please input a start date' }]},
              ]"
              :format=dateFormat />
        </a-form-item>
        <a-form-item label="End Date" class="col-md-6">
          <a-date-picker
              v-decorator="[
              'end_date',
              {rules: [{ required: true, message: 'Please input an end date' }]},
              ]"
              :format=dateFormat />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AddTerm',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
      sessions: [],
      sessionsLoading: false,
    }
  },
  methods: {
    moment,
    showModal() {
      this.visible = true
      this.getSessions()
    },
    getSessions() {
      this.sessionsLoading = true
      this.$http.get('/api/session').then(({ data }) => {
        this.sessions = data.data
        this.sessionsLoading = false
      }).catch(error => {
        this.sessionsLoading = false
        this.$neoNotify.error(error)
      })
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to add the new session!`,
            onOk: () => {
              this.$http
                .post('/api/lesson-plan/academic-terms', {
                  name: values.name,
                  session_id: values.session_id,
                  start_date: moment(values.start_date).format('YYYY-MM-DD'),
                  end_date: moment(values.end_date).format('YYYY-MM-DD'),
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Session successfully added',
                    description: `${data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
